import { render } from "./Product_Left.vue?vue&type=template&id=027a2e8e"
import script from "./Product_Left.vue?vue&type=script&lang=js"
export * from "./Product_Left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__